// libs
import React, { memo } from 'react';

// selectors
import { useSelectedSizeInventoryNudge } from 'shared/store/details/hooks/selectors';

// styles
import {
  SizeGuideNudgeContainer,
  SizeGuideNudgeText,
} from 'shared/layouts/DetailsPage/components/ProductInfo/components/SizeOptions/components/SizeInventory/styles';

// hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

interface SizeInventoryProps {
  needTopMargin?: boolean;
}
const SizeInventory = ({ needTopMargin = false }: SizeInventoryProps) => {
  // Fetch eligibility from the experiment and inventory nudge
  const isEligible = useRemoteConfig('sizeInventoryNudge');
  const inventoryNudge = useSelectedSizeInventoryNudge();

  // If not eligible or no nudge, don't render the component
  if (!inventoryNudge || !isEligible) return null;

  return (
    <SizeGuideNudgeContainer needTopMargin={needTopMargin}>
      <SizeGuideNudgeText data-at="stock-warning" data-test="stock-warning">{inventoryNudge}</SizeGuideNudgeText>
    </SizeGuideNudgeContainer>
  );
};

export default memo(SizeInventory);